
<div mat-dialog-content class="text-center">
    {{message}}
   </div>
   <div mat-dialog-actions class="row justify-content-center mt-3">
       
     <button mat-raised-button class="btn mr-2" color="primary" (click)="onConfirm()" >{{ 'CONFIRMERESERVATION.BOUTONOUI' | translate }}</button>
     <button mat-raised-button class="btn ml-2" cdkFocusInitial color="primary" (click)="onNoClick()">{{ 'CONFIRMERESERVATION.BOUTONNON' | translate }}</button>
    
   </div>